<template>
  <div>
    <az-back-button :route="{name: 'consultaDeLicitacoes'}" text="Voltar para listagem"></az-back-button>
    <az-container>
      <licitacao-visualizacao-acoes></licitacao-visualizacao-acoes>
      <div class="az-tabs">
        <v-tabs left>
          <v-tab :to="construirRota(abas.dadosGerais.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.dadosGerais.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.edital.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.edital.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.esclarecimentoImpugnacao.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.esclarecimentoImpugnacao.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.simularProposta.nomeRota)" v-if="isLicitacaoPresencial && this.licitacao.executarLicitacao === true"
                 active-class="v-tabs__item--active secondary--text">
            {{abas.simularProposta.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.acompanhamento.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.acompanhamento.titulo}}
          </v-tab>
        </v-tabs>
        <router-view></router-view>
      </div>
    </az-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import LicitacaoVisualizacaoAcoes from '@/views/pages/commons/licitacao/detalhe/acoes/LicitacaoVisualizacaoAcoes'
import {actionTypes} from '@/core/constants'

export default {
    name: 'LicitacaoVisualizacao',
    components: {LicitacaoVisualizacaoAcoes},
    data() {
        return {
            abas: {
                dadosGerais: {
                    titulo: 'Dados da Licitação',
                    nomeRota: 'licitacaoVisualizacaoDadosGerais'
                },
                edital: {
                    titulo: 'Dados do Edital',
                    nomeRota: 'licitacaoVisualizacaoEdital'
                },
                esclarecimentoImpugnacao: {
                    titulo: 'Esclarecimento/Impugnação',
                    nomeRota: 'licitacaoVisualizacaoEsclarecimentoImpugnacao'
                },
                simularProposta: {
                    titulo: 'Simular Proposta',
                    nomeRota: 'licitacaoVisualizacaoSimularProposta'
                },
                acompanhamento: {
                    titulo: 'Acompanhamento',
                    nomeRota: 'licitacaoVisualizacaoAcompanhamento'
                },
            },
            licitacaoId: null,
        }
    },
    computed: {
        ...mapState(['licitacao']),
        isLicitacaoPresencial() {
            return this.licitacao && this.licitacao.modalidade
                ? this.licitacao.modalidade.includes('PRESENCIAL')
                : false
        }
    },
    async created() {
        await this.setLicitacaoId(this.$route.params.id)
    },
    async mounted() {
        await this.buscarDadosGerais()
    },
    async beforeRouteUpdate(_to, _from, next) {
        await this.buscarDadosGerais()
        next()
    },
    methods: {
        async buscarDadosGerais() {
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS, this.licitacaoId)
        },
        construirRota(name) {
            return {
                name,
                params: {id: this.licitacaoId}
            }
        },
        setLicitacaoId(licitacaoId) {
            this.licitacaoId = licitacaoId
        },
    }
}
</script>
<style lang="stylus">
.az-tabs
  margin: 20px

  .v-tabs__div
    text-transform: none

  .v-tabs__item--active
    font-weight: bold
    border-bottom: 1px solid white
    border-left: 1px solid #ccc
    border-right: 1px solid #ccc
    border-top: 1px solid #ccc
    border-radius: 2px

  .v-tabs__item
    color: #777777
    padding: 10px 20px

  .v-tabs__slider-wrapper
    display: none

  .v-tabs__container
    border-bottom: 1px solid #ccc

  .v-text-field__slot
    font-size: 14px

  .v-select__selections
    font-size: 14px

</style>